export const Tools = {
  displayNames: {
    vsaasAccessControlReport: "Reporte de Control de Acceso",
    vsaasBulkStateChange: "Cambio de Estado Masivo",
    vsaasCargoContainerLog: "Registro de Contenedores",
    vsaasCountReport: "VSaaS BI",
    vsaasEventImageReport: "Reporte de Imágenes de Eventos",
    vsaasFaceDatabase: "Colecciones de Rostros",
    vsaasFaceDetectionsSearch: "Búsqueda de Detecciones Faciales",
    vsaasGranularity: "Dashboard de Granularidad",
    vsaasOpenGateReport: "Reporte de Apertura de Puerta",
    vsaasOperabilitySummary: "Resumen de Assets Operativos",
    vsaasRoundsReportV2: "Reporte de Rondas",
    vsaasTelegramEvents: "Eventos de Telegram",
    xompassAnnualReport: "Reporte anual",
    xompassBIPanels: "BI Panel",
    xompassCCTV: "CCTV",
    xompassDetectionHistory: "Historial de Detecciones",
    xompassDetectionsHeatmap: "Mapa de Calor de Detecciones",
    xompassDeviceEventDashboard: "Dashboard de Eventos Edge",
    xompassEdgeMonitoring: "Monitoreo de Equipos Edge",
    xompassEmbeddedReports: "Reportes Embebidos",
    xompassEventDashboard: "Dashboard de Eventos",
    xompassEventDashboardDemo: "Demo Dashboard de Eventos",
    xompassEventDetectionReport: "Reporte de Detecciones de Evento",
    xompassEventHistory: "Historial de Eventos",
    xompassEventReport: "Reporte de Eventos",
    xompassForensicAnalysis: "Análisis Forense",
    xompassForensicLicensePlate: "Búsqueda de Patentes",
    xompassForensicLicensePlateBlacklist: "Patentes de interes",
    xompassForensicLicensePlateBlacklistDetections: "Detecciones de interés",
    xompassForensicReconstruction: "Reconstrucción Forense",
    xompassForensicRetail: "Retail - Búsqueda Forense",
    xompassGIS: "Gis",
    xompassImportantEvents: "Eventos Destacados",
    xompassKeyValueData: "Datos Históricos",
    xompassLCEventReport: "Reporte de Eventos Las Condes",
    xompassOvaDashboard: "Monitoreo de OVAs",
    xompassPeopleCounterDailyReport: "Reporte de Conteo Diario",
    xompassPeopleCounterReports: "Reporte de Conteo (legacy)",
    xompassPeopleCounterWeeklyReport: "Reporte de Conteo Semanal",
    xompassRealTime: "Tiempo Real",
    xompassResponseProtocol: "Protocolos de Respuesta",
    xompassRoundsReport: "Reporte de Rondas (legacy)",
    xompassSCADA: "Esquemas de Proceso",
    xompassStoreAnomaliesDashboard: "Gestión de ventas anómalas",
    xompassStoreAnomaliesReport: "Reporte de ventas anómalas",
    xompassStoreForensicSales: "Ventas Retail",
    xompassStoreHeatmap: "Heatmap de Tienda (beta)",
    xompassStoreOpeningReport: "Reporte de Apertura de tienda",
    xompassStoryline: "Storyline",
    xompassTimeSeries: "Series de Tiempo",
    xompassTrafficFlowAnalysis: "Análisis de flujo de tráfico",
    xompassVehicleInspectionReport: "Reporte de Inspección Vehicular",
  },
};
